import { muroDeSeries7 } from '../lib/series7';

/**
 * Pure screen-selection for AutoSplitModal (Phase 2). No React — unit-testable.
 *
 * Given the server's `affordability` payload, returns which screen ("wall") to paint:
 *   full       k >= n                                  → process all
 *   partial    0 < k < n && pending_fit                → process k now, save rest
 *   k0         k == 0   && pending_fit                 → save all to pending
 *   impossible !pending_fit && impossible_in_any_plan  → doc too big, manual split
 *   contact    !pending_fit && contact_support         → top plan maxed, free up pending
 *   overcap    !pending_fit                            → pending tope full, free space
 */
export function classifyWall(aff, mode) {
  if (!aff) return 'full';
  // series-7 (#492, 24-sep-2026): con `series7` el servidor ya no produce los muros de
  // "demasiado grande" ni de soporte, y el resto que no cabe en Pendientes lo dice su
  // renglon. Sin `series7` (servidor viejo) todo lo de abajo queda como estaba.
  if (aff.series7) return muroDeSeries7(aff.series7, mode);
  const { k, n, pending_fit, contact_support, impossible_in_any_plan } = aff;
  if (k >= n) return 'full';
  // Resume mode (/pending): the remaining parts are ALREADY saved as pending, so there's
  // no "save the rest" / over-cap decision — process what fits now, the rest just stay.
  if (mode === 'resume') return 'partial';
  if (pending_fit) return k === 0 ? 'k0' : 'partial';
  if (impossible_in_any_plan) return 'impossible';
  if (contact_support) return 'contact';
  return 'overcap';
}
